function NavSpacer() {
    return <div className="sm:h-nav-sm md:h-nav-md lg:h-nav-lg xl:h-nav-xl"></div>;
}
export default NavSpacer;